import React from 'react';

import CollectionsProvider from './CollectionsContext';
import CollectionsContent from './components/CollectionsContent/CollectionsContent';

const Collections = () => {
    return (
        <CollectionsProvider>
            <CollectionsContent />
        </CollectionsProvider>
    );
};

Collections.propTypes = {};

export default Collections;
